import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { CtgSelectCondition, CtgSelectComponent } from '../ctg-select/ctg-select.component';
import { CommonService } from 'src/app/service/common.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ItemSearchCond } from 'src/app/common/config';
import { BarcodeDialogComponent } from 'src/app/dialog/barcode-dialog/barcode-dialog.component';
import { DialogService } from 'src/app/service/dialog.service';

export class ItemSelectSimpleCondition {
  public ctgSelectCondition: CtgSelectCondition = new CtgSelectCondition(this.fb);

  public formGroup: FormGroup = this.fb.group({
    storeCd: ['', Validators.required],
    itemCode: [''],
    itemName: ['']
  });
  public  itemSearchCondConfig: ItemSearchCond;

  constructor(private fb: FormBuilder) {
  }
}

@Component({
  selector: 'app-item-select-simple',
  templateUrl: './item-select-simple.component.html',
  styleUrls: ['./item-select-simple.component.css']
})
export class ItemSelectSimpleComponent implements OnInit, OnDestroy {

  // public ctgSelectCondition: CtgSelectCondition;
  @Input('itemSelectSimpleCondition') public itemSelectSimpleCondition: ItemSelectSimpleCondition;
  @Input('allStoresFlag') public allStoresFlag: boolean = false;
  @Input("noQuery") public noQuery: boolean = false;
  @Output('doQueryItemSimple') public clickQuery: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(CtgSelectComponent, { static: true }) public ctgSelect: CtgSelectComponent;

  storeCdSubscription: Subscription;

  constructor(
    public commonService: CommonService,
    private fb: FormBuilder,
    private dialogService: DialogService
  ) {

  }

  ngOnInit() {
    this.itemSelectSimpleCondition.formGroup.get('storeCd').setValue((this.allStoresFlag) ? "" : this.commonService.loginUser.storeCd);
    this.itemSelectSimpleCondition.ctgSelectCondition.storeCd = (this.allStoresFlag) ? "" : this.commonService.loginUser.storeCd;
    this.storeCdSubscription = this.itemSelectSimpleCondition.formGroup.get('storeCd').valueChanges
      .subscribe(
        data => this.ctgSelect.setStoreCd(this.itemSelectSimpleCondition.formGroup.get('storeCd').value)
      );
  }

  ngOnDestroy() {
    if (this.storeCdSubscription) {
      this.storeCdSubscription.unsubscribe();
    }
  }

  doQuery() {
    this.clickQuery.emit();
  }

  onScan(barcode: string) {
    this.itemSelectSimpleCondition.formGroup.get("itemCode").setValue(barcode);
    this.doQuery();
  }

  openBarcodeDialog() {
    this.dialogService.openBarcodeDialog().subscribe(
      (data) => {
        if (data != undefined && data != null) {
          this.itemSelectSimpleCondition.formGroup.get("itemCode").setValue(data);
          this.doQuery();
        }
      }
    );
    /*
    const dialogRef = this.commonService.dialog.open(BarcodeDialogComponent, {
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != undefined && data != null) {
          this.itemSelectSimpleCondition.formGroup.get("itemCode").setValue(data);
          this.doQuery();
        }
      }
    )
    */
  }
}
